import React, { Component } from 'react';
import { Form, Control, Errors } from "react-redux-form";
import {isRequired, required} from "../field_validations";
import _ from 'lodash';
import {toInt} from "../parsers";

class NotificaciontTypeEditForm extends Component{
	render(){
		const { status/*, groupsPhases */} = this.props;

		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="notifications_types.edit" onSubmit={(entity) => this._handleSubmit(entity)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>

						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="name" className="label">Nombre <span className="small has-text-danger">*</span></label>
								<Control.text model=".name" id=".name" className="input" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'Campo Requerido'}}/>
							</div>

							<div className="control">
								<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".status_id" id="status" className="select" errors={{required}} validateOn="change">
										<option value="" defaultValue>--- Estatus ---</option>
										{_.map(status.data, (stat, k) => {
											return <option value={stat.id} key={k}>{stat.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="priority" className="label">Prioridad <span className="small has-text-danger">*</span></label>
								<Control.text model=".priority" id="priority" parser={ toInt } type="number" min={1} step={1} className="input" errors={{required}} validateOn="change"/>
								<Errors model=".priority" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El campo es obligatorio'}} />
							</div>

							<div className="control">
								<div className="notification is-warning">
									<p><i className="fa fa-info"/>&nbsp; Si se tienen dos tipos de revisiones, se tomará en cuenta </p>
									<p>la notificación con mayor prioridad, donde 1 es la menor prioridad posible.</p>
								</div>
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<div className="message is-primary">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="assign_codes" className="checkbox">
													<Control.checkbox model=".assign_codes" id="assign_codes" className="checkbox" isToggle={1}/>
													<span style={{whiteSpace:'normal'}}> Asignación de folios </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						{/*<div className="field is-grouped">
							<div className="control">
								<label htmlFor="phase_group_id" className="label">Proceso <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".phase_group_id" name="phase_group_id" id="phase_group_id" errors={{required}} validateOn="change">
										<option value="ninguno">-- Seleccionar proceso --</option>
										{_.map(groupsPhases.list, (opt, k) => {
											return <option key={k} value={opt.id}>{opt.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".phase_group_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El proceso es obligatorio'}} />
							</div>
						</div>*/}

						<div className="field">
							<div className="control is-expanded">
								<label htmlFor="description" className="label">Descripción </label>
								<Control.textarea model=".description" id=".description" className="textarea"/>
								<Errors model=".description" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'Campo Requerido'}}/>
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<Control.button model="notifications_types.edit" className="button is-danger" onClick={() => this.props.history.push('/notificaciones')}>Regresar</Control.button>
							</div>
							<div className="control">
								<Control.button model="notifications_types.edit" className="button is-success" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	_handleSubmit(values){
		this.props.notificationTypeEditSave(values)
	}

	_validateSave(){
		const {notifications_types} = this.props;
		let nc = _.find(notifications_types.permissions, (o) => {return o==='Create'});
		let nu = _.find(notifications_types.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(notifications_types.edit) && notifications_types.edit.id){
			if(nu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(notifications_types.edit) && _.isEmpty(notifications_types.edit.id)){
			if(nc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default NotificaciontTypeEditForm;


// WEBPACK FOOTER //
// ./src/elements/notifications/form.jsx